/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import {
    RESET_ALL_COLLECTION_SCREEN_FILTERS,
    RESET_COLLECTION_SCREEN_FILTER,
    SET_COLLECTION_FILTER_ITEMS_LOADING,
    SET_COLLECTION_FILTER_SORT_ORDER,
    SET_COLLECTION_IS_LAST_PAGE,
    SET_COLLECTION_PAGE_LOADING,
    SET_COLLECTION_SCREEN_CARET,
    SET_COLLECTION_SCREEN_FILTER_DETAILS,
    SET_COLLECTION_SCREEN_LAST_FOCUSED_ITEM_POSITION,
    SET_FOCUS_ON_COLLECTION_SCREEN_DELETE_BUTTON,
    SET_FOCUS_ON_COLLECTION_SCREEN_GO_TO_EPISODE_BUTTON,
} from './collectionscreen.types';
import { TCollectionFilterDetails } from './TCollectionFilterDetails';

export const resetAllCollectionScreenFiltersAction = () => {
    return {
        type: RESET_ALL_COLLECTION_SCREEN_FILTERS,
    };
};

export const resetCollectionScreenFilterAction = (filter: string) => {
    return {
        type: RESET_COLLECTION_SCREEN_FILTER,
        payload: { filter },
    };
};

export const setCollectionScreenFilterDetailsAction = (
    filter: string,
    filterDetails: TCollectionFilterDetails,
) => {
    return {
        type: SET_COLLECTION_SCREEN_FILTER_DETAILS,
        payload: {
            filter,
            filterDetails,
        },
    };
};

export const setCollectionScreenCaretVisibleAction = (isCaretVisible: boolean) => ({
    type: SET_COLLECTION_SCREEN_CARET,
    payload: { isCaretVisible },
});

export const setFocusOnCollectionScreenGoToEpisodeAction = (
    filter: string,
    isGoToEpisodeButtonEnable: boolean,
) => {
    return {
        type: SET_FOCUS_ON_COLLECTION_SCREEN_GO_TO_EPISODE_BUTTON,
        payload: {
            filter,
            isGoToEpisodeButtonEnable,
        },
    };
};

export const setFocusOnCollectionScreenDeleteAction = (
    filter: string,
    isDeleteButtonEnable: boolean,
) => {
    return {
        type: SET_FOCUS_ON_COLLECTION_SCREEN_DELETE_BUTTON,
        payload: {
            filter,
            isDeleteButtonEnable,
        },
    };
};

export const setCollectionScreenLastFocusedItemPositionAction = (
    filter: string,
    lastPosition: number,
) => {
    return {
        type: SET_COLLECTION_SCREEN_LAST_FOCUSED_ITEM_POSITION,
        payload: {
            filter,
            lastPosition,
        },
    };
};

export const setCollectionFilterSortOrder = (filter: string, sortOrder: string) => {
    return { type: SET_COLLECTION_FILTER_SORT_ORDER, payload: { filter, sortOrder } };
};

export const setCollectionFilterItemLoading = (isLoadingFilterItems: boolean) => {
    return { type: SET_COLLECTION_FILTER_ITEMS_LOADING, payload: { isLoadingFilterItems } };
};

export const setCollectionIsLastPage = (isLastPage: boolean) => {
    return { type: SET_COLLECTION_IS_LAST_PAGE, payload: { isLastPage } };
};

export const setCollectionPageLoading = (isLoadingPage: boolean) => {
    return { type: SET_COLLECTION_PAGE_LOADING, payload: { isLoadingPage } };
};
